var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppNavigationTop',{attrs:{"navigationInfo":_vm.AppNavigationTopInfo}}),_c('div',{staticClass:"mt-4"}),(this.tag !== 'U1')?_c('TreeList',{attrs:{"data":"{tag='K6'}"}}):_vm._e(),_c('AppNavigationBottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }